import React, { Component } from "react";
import Table from "../../../components/table/Table";
import { Navigate, Routes } from "react-router-dom";
import moment from "moment";
import { saveAs } from "file-saver";
import SwalServices from "../../../services/swalServices/SwalServices";
import ActionContainer from "../../../components/UIComponent/ActionTableComponent/actionContainer";
import DropdownAction from "../../../components/dropdown/DropdownAction";
import MembershipTaskListServices from "../../../services/axiosServices/apiServices/MembershipTaskListServices";
import DropdownSelect from "../../../components/dropdown/Dropdown";
import MembershipTaskListProcess from "./MembershipTaskListProcess";
import CorporateMemberServices from "../../../services/axiosServices/apiServices/CorporateMemberServices";
import BookingServices from "../../../services/axiosServices/apiServices/BookingServices";
import {
  CommonValidationMessages,
  CommonSuccessMessages,
  SuccessMessage,
} from "../../../utils/Messages";
import {
  isValidForm,
  validate,
} from "../../../utils/validation/CommonValidator";
import SendForApprove from "./SendApproveModal";
import SendPaymentLink from "./SendPaymentLink";
import SendQuotation from "./SendQuotation";
import SendInvoice from "./SendInvoice";
import EscalateModal from "./EscalateModal";
import SendClarifications from "./SendClarifications";
import {
  yearDifference,
  //, monthDifference
} from "../../../utils/DateUtils";
import { encryptAES } from "../../../utils/Encryption";
import Selector from "../../../components/dropdown/commonDropdown/Selector";
import WelcomeLetter from "./WelcomeLetter";
import { getAuditContext } from "../../../utils/audit/AuthenticationLibrary";


export default class MembershipTaskList extends Component {
  constructor(props) {
    super(props);
    this.TaskListServices = new MembershipTaskListServices();
    this.BookingServices = new BookingServices();
    this.corporateMemberServices = new CorporateMemberServices();
    this.swalServices = new SwalServices();
    this.state = {
      companyUEN: "",
      statusId: 0,
      companyName: "",
      companyProfile: {
        issuedCapitalId: 0,
        paidUpCapital: "",
        stakeholderEquities: "",
        realStateAndRelatedActivitiesId: "",
        overseasOfficeId: 0,
        totalGroupAssetId: 0,
        employmentSizeId: 0,
        interestedInId: 0,
        getToKnowId: 0,
      },
      representatives: {
        corporateMemberId: 0,
        salutation: 0,
        firstName: "",
        lastName: "",
        designation: "",
        jobPosition: "",
        bussinessEmail: "",
        countryDailingCodeID: 0,
        bussinessContactNo: "",
        isMainRepresentative: true,
        comments: "",
        passwordSalt: ""
      },
      alternativeRepresentatives: {
        corporateMemberId: 0,
        salutation: 0,
        firstName: "",
        lastName: "",
        designation: "",
        jobPosition: "",
        bussinessEmail: "",
        countryDailingCodeID: 0,
        bussinessContactNo: "",
        isMainRepresentative: false,
        comments: "",
        passwordSalt: ""
      },
      projects: [],
      inProgressProjects: [],
      boardOfDirectors: [],
      committeeApprovalStatusList: [],


      topManagements: [],
      historyLogDetail: [],
      isValidStartUpMember: true,
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
        status: 0,
        dateFrom: "",
        dateTo: "",
        filterByStatus: "",
        filterByTransactionType: 0
      },
      filterStatusId: 0,
      totalResultes: "",
      taskList: [],
      isLoading: false,
      isLoadingPayment: false,
      isLoadingReject: false,
      isLoadingPDF: false,
      isLoadingApprove: false,
      isLoadingApproveRenew: false,
      isLoadingClarification: false,
      isLoadingWelcomeDetail: false,
      isLoadingSendMail1: false,
      isLoadingSendMail2: false,
      route: null,
      redirect: null,
      clarification: '',
      welcomeletter: '',

      membershipCommitteeApprovalDetails: {
        comments: "",
        deadLineDate: "",
        isMembershipCommitteeApproval: true,
        taskId: 0,
        corporateMemberID: 0,
        membershipType: "",
      },
      managementCommitteeApprovalDetails: {
        comments: "",
        deadLineDate: "",
        isMembershipCommitteeApproval: false,
        taskId: 0,
        corporateMemberID: 0,
        membershipType: "",

      },
      membershipAdditionalInformationDetails: {
        taskId: 0,
        additionalNotes: "",
        additionalDate: "",
        isMembershipCommitteeApproval: true,
      },
      managementAdditionalInformationDetails: {
        taskId: 0,
        additionalNotes: "",
        additionalDate: "",
        isMembershipCommitteeApproval: false,
      },

      // loader


      isMembershipSendApprovalLoading: false,
      isManagementSendApprovalLoading: false,
      isMembershipSubmitLoading: false,
      isManagementSubmitLoading: false,

      membershipCommitteeApproval: [],
      managementCommitteeApproval: [],
      //Dropdown Arrays Start
      membershipType: [],
      membershipRevenue: [],
      countries: [],
      serviceType: [],
      industriesServed: [],
      associationBenefits: [],
      getToKnow: [],
      associationBenefits: [],
      mrMrs: [],
      designation: [],
      years: [],
      emailCirculars: [],
      servicesTypeData: [],
      industriesServedData: [],
      billingCategories: [],
      associationBenefitsData: [],
      ordinaryEndorsers: [],
      allEndorsers: [],
      ordinaryRepresentative: [],
      allRepresentative: [],
      transactionTypes: [],
      applicationStatus: [],
      totalGroupAssets: [],
      ProjectDevelopmentTypes: [],
      countriesDailing: [],
      jobPosition: [],
      submissionTypeList: [],
      CountriesForCO: [],     //Dropdown Arrays End
      sendClarificationMail: {
        taskId: 0,
        corporatememberId: 0,
        companyName: '',
        companyUEN: '',
        mainRepresentativeName: '',
        mainRepresentativeEmail: ''
      },
      selfDeclarationComment: "",
      selfDeclaration: "",
      isSelfComment: 0,

      taskDetails: {
        expiryDate: "",
        approvalDate: "",
        taskId: 0,
        memberId: 0,
        contactRoleId: 0,
        groupAssetId: 0,

        billingCategoryId: 0,
        isMCApprovalSubmitted: false,
        subscriptionStartDate: null,
        subscriptionEndDate: null,
        membershipTaskStatusId: 0,
        transactionTypeId: 0,
        approvalDate: null,
        isEndorsed: false,
        isCouncilApproved: false,
        // companyUEN: "",
        // companyName: "",
        membershipTypeId: 0,
        organisationName: "",
        organisationUEN: "",
        incorporationDate: null,
        paidUpCapital: 0,
        servicesTypeId: 0,
        industriesServedId: 0,
        associationBenefitsId: 0,
        generalEmailAddress: "",
        generalBusinessTelephone: null,
        statusId: 0,
        endorsersId1: 0,
        endorsersId2: 0,
        representativeId1: 0,
        representativeId2: 0,
        isRejected: 0,
        designation: '',
        firstName: '',
        lastName: '',
        entranceFee: 0,
        annualFee: 0,
        includedChapter: 0,
        additionalChapterPrice: 0,
        subtotalPrice: 0,
        gstPrice: 0,
        discountedPrice: 0,
        totalPrice: 0,
        paymentsCreditsApplied: 0,
        netTotal: 0,
        membersReceiptId: 0,
        subscriptionFee: 0,
        membershipPaymentTypeId: 0,
        transactionId: "",
        voucherCode: "",
        membershipPaymentInvoicePath: '',
        endorsementSatusForEndorser1: 0,
        endorsementSatusForEndorser2: 0,

        committeeApprovalDate: null,
        endorsersId1Name: "",
        endorsersId2Name: "",

        //Reinstatement Field
        reinstatementRequestDate: "",
        reinstatementAmount: 0,
        reinstatementEndDate: 0,
        reinstatementStartDate: 0,
        isManagementCommitteeApprovalSubmitted: null,
        isMembershipCommitteeApprovalSubmitted: null,

        //C/O for Billing

        isCOforBiilingChecked: false,
        billingEntity: "",
        billingAttention: "",
        billingEmailAddress: "",
        attentionSalutationId: 0,
        billingCountryId: 0,
        billingAddress: "",
        billingPostalCode: "",
        SelfDeclaration: "",
        IsSelfComment: 0

      },
      // representativeDetails: {
      //   bussinessContactNo: "",
      //   bussinessEmail: "",
      //   corporateMemberId: 0,
      //   designation: "",
      //   firstName: "",
      //   individualMemberId: 0,
      //   isMainRepresentative: "",
      //   jobPosition: 0,
      //   lastName: "",
      //   salutation: 0
      // },
      representativeDetails: [],
      alternativeRepresentative: [],
      boardAndTopMtgList: [],
      boardDirectorList: [],
      topManagementList: [],
      ordinaryMainProjectList: [],
      ordinaryProjectsCompletedList: [],
      ordinaryProjectsInCompleteList: [],
      // historyLogDetail: {
      //   taskId: 0,
      //   endorsersRepresentativeId: 0,
      //   companyName: '',
      //   representativeName: '',
      //   endorsementStatus: '',
      //   endorserCategory: '',
      //   issuedDate: null,
      //   endorserComment: '',
      // },
      setSendClarifications: false,
      setWelcomeletter: false,
      setDropdownOpen: false,
      membershipTaskListProcessModal: false,
      setAddeditModalOpen: false,
      setPaymentLink: false,
      sendQuotation: false,
      sendInvoice: false,
      sendEscalation: false,
      sendReject: false,
      basePriceTable: [],
      allowableDiscountTable: [],
      percentageDiscountTable: [],
      systemCalculatedTable: [],
      disablePaymentButton: false,
      disableSubscription: true,
      sendEscalate: {
        memberId: 0,
        firstName: "",
        lastName: "",
        organisationName: "",
        organisationUEN: "",
        generalEmailAddress: "",
        generalBusinessTelephone: 0,
        internalNotes: "",
      },
      filterOrdinaryEndorsersList: [],
      filterAllEndorsers: [],
      membershipCommitteeInfoAvailable: false,
      isMembershipCommitteeadditionalInfo: false,
      managementCommitteeInfoAvailable: false,
      isManagementCommitteeadditionalInfo: false,
      validationRule: {
        membershipTypeId: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Membership Type'),
          },
        ],

        //Organisation Profile Validation Rules
        organisationName: [
          {
            type: 'require',
            message: CommonValidationMessages.FieldRequired.replace('{0}', 'Organisation Name'),
          },
        ],
        organisationUEN: [
          {
            type: 'require',
            message: CommonValidationMessages.FieldRequired.replace('{0}', 'Organisation UEN'),
          },
        ],
        incorporationDate: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Incorporation Date'),
          },
        ],
        subscriptionStartDate: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Commencement Date'),
          },
        ],
        subscriptionEndDate: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Commencement Date'),
          },
        ],
        paidUpCapital: [
          {
            type: 'require',
            message: CommonValidationMessages.FieldRequired.replace('{0}', 'Paid Up Capital'),
          },
        ],
        // mailingCountryId: [
        //   {
        //     type: 'require',
        //     message: Messages.CommonValidationMessages.SelectRequired.replace('{0}', 'Country of Mailing Address'),
        //   },
        // ],

        //Other Information Validation Rules
        servicesTypeData: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Types of Services Your Organisation Offers'),
          },
        ],
        industriesServedData: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Types of Industries Your Organisation Serves'),
          },
        ],
        associationBenefitsId: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Your Organisation Benefits from Joining The Association'),
          },
        ],

        //Endorsers
        endorsersId1: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Original Member Endorser'),
          },
        ],
        endorsersId2: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Endorser Company'),
          },
        ],
        representativeId1: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Representative'),
          },
        ],
        representativeId2: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Representative'),
          },
        ],
        comments: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Comments'),
          },
        ],
        comments2: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Comments'),
          },
        ],
        deadLine: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'DeadlineDate'),
          },
        ],
      },


      validationRuleForManagement: {
        comments: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Comments'),
          },
        ],

        deadLineDate: [
          {
            type: 'require',
            message: CommonValidationMessages.FieldRequired.replace('{0}', 'DeadLine Date'),
          },
          {
            type: 'minDateCheck',
            message: CommonValidationMessages.MinDateCheck.replace('{0}', 'Deadline'),
          }
        ],

      },

      validationRuleForMembership: {
        comments: [
          {
            type: 'require',
            message: CommonValidationMessages.SelectRequired.replace('{0}', 'Comments'),
          },
        ],

        deadLineDate: [
          {
            type: 'require',
            message: CommonValidationMessages.FieldRequired.replace('{0}', 'DeadLine Date'),
          },
          {
            type: 'minDateCheck',
            message: CommonValidationMessages.MinDateCheck.replace('{0}', 'Deadline'),
          }
        ],

      },
      validState: {
        isValid: true,
        error: {},
      },
      validStateForManagement: {
        isValid: true,
        error: {},
      },
      actionDropdown: ["Process", "Delete"],
      //actionDropdown: [ "Delete"],
    };
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    let audit = getAuditContext();

    this.getAllDropdownsForTaskList();
    document.addEventListener("mousedown", this.handleClickOutside);
    this.setState({ createdAppId: audit.appId, createdBy: audit.adminUserId });

  }


  applyFilter = () => {
    const flags = [
      { key: "isSubmitted", statusId: 1 },
      { key: "isSubmitted(R)", statusId: 11 },
      { key: "pendingMembershipCommittee", statusId: 5 },
      { key: "isMembershipCommitteeApproved", statusId: 7 },
      { key: "isSentForClarification", statusId: 9 },
      { key: "pendingManagementCommittee", statusId: 6 },
      { key: "isManagementCommitteeApproved", statusId: 8 },
      { key: "isPendingPayment", statusId: 3 },
    ];

    let selectedStatusId = null;
    let matchedKey = null;

    for (const item of flags) {
      if (localStorage.getItem(item.key) === "true") {
        selectedStatusId = item.statusId;
        matchedKey = item.key;
        break;
      }
    }

    if (selectedStatusId !== null) {
      const selectedStatus = this.state.applicationStatus.find(item => item.id === selectedStatusId);
      let pagi = { ...this.state.pagination };
      pagi.filterByStatus = selectedStatus ? selectedStatus.name : null;

      this.setState(
        { pagination: { ...pagi }, filterStatusId: selectedStatusId },
        () => {
          this.getAllTaskList();
          if (matchedKey) localStorage.removeItem(matchedKey);
        }
      );
    } else {
      this.getAllTaskList();
    }
  };


  handleRadioClick = (e) => {
    const value = e.target.value;
    this.setState({
      selfDeclarationComment: value,
      isSelfComment: value === "Yes" ? 1 : 0,
      selfDeclaration: value === "Yes" ? this.state.selfDeclaration : ""
    });
  };



  handleChangeMultiDropdown(selected, identity) {
    if (identity === "ServicesType") {
      const maxSelections = 3;
      const limitedSelections = selected.slice(0, maxSelections);
      this.setState({
        servicesTypeData: limitedSelections
      });
    } else if (identity === "IndustriesServed") {
      const maxSelections = 3;
      const limitedSelections = selected.slice(0, maxSelections);
      this.setState({
        industriesServedData: limitedSelections
      });
    }
    else if (identity === "AssociationBenefits") {
      const maxSelections = 3;
      const limitedSelections = selected.slice(0, maxSelections);
      this.setState({
        associationBenefitsData: limitedSelections
      });
    }
  }
  handleChangeForRepresentative = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    let representativeDetails = this.state.representatives;
    representativeDetails[name] = value;
    this.setState({ representatives: representativeDetails });
  }


  handleChangeForApproval = (event, identity) => {
    let name = event.target.name;
    let value = event.target.value;
    let id = event.target.id;


    if (identity === "comments1") {
      let details = this.state.membershipCommitteeApprovalDetails;
      details[name] = value;

      this.setState({ membershipCommitteeApprovalDetails: details })
    }
    else if (identity === "datePicker1") {

      let details = this.state.membershipCommitteeApprovalDetails;
      details[name] = value;

      this.setState({ membershipCommitteeApprovalDetails: details })
    }
    else if (identity === "comments2") {
      let details = this.state.managementCommitteeApprovalDetails;
      details[name] = value;

      this.setState({ managementCommitteeApprovalDetails: details })
    }
    else if (identity === "datePicker2") {
      let details = this.state.managementCommitteeApprovalDetails;
      details[name] = value;

      this.setState({ managementCommitteeApprovalDetails: details })
    }
    else if (identity === "additionalNotes1") {
      let details = this.state.membershipAdditionalInformationDetails;
      details[name] = value;

      this.setState({ membershipAdditionalInformationDetails: details })
    }
    else if (identity === "additionalDate1") {
      let details = this.state.membershipAdditionalInformationDetails;
      details[name] = value;

      this.setState({ membershipAdditionalInformationDetails: details })
    }
    else if (identity === "additionalNotes2") {
      let details = this.state.managementAdditionalInformationDetails;
      details[name] = value;

      this.setState({ managementAdditionalInformationDetails: details })
    }
    else if (identity === "additionalDate2") {
      let details = this.state.managementAdditionalInformationDetails;
      details[name] = value;

      this.setState({ managementAdditionalInformationDetails: details })
    }
  }


  committeeApproval = (e, request) => {
    e.preventDefault();
    const isMembership = request.isMembershipCommitteeApproval === true;
    if (this.isValidateAllFieldsForApproval(isMembership)) {

      this.setState({
        isMembershipSendApprovalLoading: isMembership,
        isManagementSendApprovalLoading: !isMembership,
      });

      if (request) {
        this.TaskListServices.SendEmailForMembershipAndManagmentCommitteeApproval(request)
          .then((response) => {
            if (response.statusCode === 200 && response.responseItem?.responseContent) {
              this.swalServices.Success(`Email has been sent to  ${isMembership ? 'membership' : 'management'} committee.`);
              if (isMembership) {
                this.setState({
                  membershipCommitteeInfoAvailable: true,
                });
              } else {
                this.setState({
                  managementCommitteeInfoAvailable: true,
                });
              }
            } else {
              this.swalServices.Error(response.error);
            }

            this.setState({
              isMembershipSendApprovalLoading: false,
              isManagementSendApprovalLoading: false,
            });
            this.getTaskByCompanyId(request.taskId);
          });

      }
    }
    // this.swalServices.Error("Please fill all fields");/
  };

  resendCommitteeApproval = (item) => {

    const CommitteeApprovalDetails = item.isMembershipCommitteeApproval
      ? this.state.membershipCommitteeApprovalDetails
      : this.state.managementCommitteeApprovalDetails; let request = {
        committeeMemberId: item.committeeMemberId,
        corporateMemberID: item.corporateMemberId,
        companyName: CommitteeApprovalDetails.companyName,
        membershipType: CommitteeApprovalDetails.membershipType,
        isMembershipCommitteeApproval: item.isMembershipCommitteeApproval,
        comments: CommitteeApprovalDetails.comments,
        deadLineDate: CommitteeApprovalDetails.deadLineDate,
        taskId: CommitteeApprovalDetails.taskId
      }
    this.TaskListServices.ResendEmailForMembershipAndManagmentCommitteeApproval(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem?.responseContent) {
        this.swalServices.Success("Email has been resent to Committee Members!")
      }
    })

  }
  additionalInfomationSubmit(e, request) {
    let audit = getAuditContext();

    e.preventDefault();
    const isMembership = request.isMembershipCommitteeApproval === true;
    request.createdBy = audit.adminUserId;;
    request.createdAppId = audit.appId;

    this.setState({
      isMembershipSubmitLoading: isMembership,
      isManagementSubmitLoading: !isMembership,
    });

    if (request) {
      this.TaskListServices.UpdateCommitteeAdditionalInformation(request).then((response) => {
        if (response.statusCode === 200 && response.responseItem?.responseContent) {
          this.swalServices.Success((isMembership ? "Membership" : "Management") + " Committee has completed its review.");
          if (isMembership) {
            this.setState({
              isMembershipCommitteeadditionalInfo: true,
            });
          } else {
            this.setState({
              isManagementCommitteeadditionalInfo: true,
            });
          }
        }
        this.setState({
          isMembershipSubmitLoading: false,
          isManagementSubmitLoading: false,
        });
        this.getTaskByCompanyId(request.taskId);
      });
    }

  }


  handleChangecontactinformation = (index, fieldName, value) => {
    const { taskDetails } = this.state;
    let updatedContactInfo = [...taskDetails.contactInformationDetail];
    updatedContactInfo[index] = {
      ...updatedContactInfo[index],
      [fieldName]: value
    };

    this.setState({
      taskDetails: {
        ...taskDetails,
        contactInformationDetail: updatedContactInfo
      }
    });
  };

  getAllTaskList = (pagination = this.state.pagination) => {
    this.setState({ isLoading: true });
    this.TaskListServices.getAllTaskList(pagination).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let details = response.responseItem.responseContent.itemList;
        details.map((key, index) => {
          key.registrationDate = moment(key.registrationDate).format(
            "DD MMM YYYY"
          );
          if (key.companyAdminEmail === null || key.companyAdminEmail === "") {
            key.companyAdminEmail = "-";
          }
          if (key.companyName === null || key.companyName === "") {
            key.companyName = "-";
          }
          if (key.companyUEN === null || key.companyUEN === "") {
            key.companyUEN = "-";
          }
          if (key.applicationStatusName === null || key.applicationStatusName === "") {
            key.applicationStatusName = "-";
          }
          if (key.transactionType === null || key.transactionType === "") {
            key.transactionType = "-";
          }
          return key;
        });
        this.setState({ taskList: details });
        this.setState({
          totalResultes: response.responseItem.responseContent.totalCount,
        });
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    });
  };

  getAllDropdownsForTaskList = () => {

    this.TaskListServices.getAllDropdownsForTaskList().then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let membershipType = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "MembershipType");

        let membershipRevenue = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "MembershipRevenue");
        let submissionType = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "SubmissionType");

        let countries = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "Countries");

        let serviceType = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "ServicesType");
        serviceType = serviceType.map((p) => ({
          value: p.id,
          label: p.name,
        }));

        let associationBenefits = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "AssociationBenefits");
        associationBenefits = associationBenefits.map((p) => ({
          value: p.id,
          label: p.name,
        }));

        let industriesServed = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "IndustriesServed");
        industriesServed = industriesServed.map((p) => ({
          value: p.id,
          label: p.name,
        }));

        let getToKnow = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "CorporateGetToKnowUs");

        // let associationBenefits = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "AssociationBenefits");

        let mrMrs = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "MrMrs");

        let designation = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "Designation");

        let years = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "Years");

        let emailCirculars = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "EmailSubscription");

        let billingCategories = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "BillingCategory");
        let transactionTypes = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "TransactionType");
        // let applicationStatus = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "ApplicationStatus");
        let applicationStatus = response.responseItem.responseContent
          .filter((drp) => drp.dropdownName === "ApplicationStatus")
          .sort((a, b) => {
            if (a.valueOrdering === 1) return -1;
            if (b.valueOrdering === 1) return 1;
            if (a.valueOrdering === 11) return -1;
            if (b.valueOrdering === 11) return 1;
            return a.valueOrdering - b.valueOrdering;
          });


        let totalGroupAssets = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "TotalGroupAssetsType");
        let ProjectDevelopmentTypes = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "ProjectDevelopmentTypes");
        let CommitteeApprovalStatus = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "CommitteeApprovalStatus");
        ProjectDevelopmentTypes = ProjectDevelopmentTypes.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        let countriesDailingCode = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "CountriesDailing").sort((a, b) => {
          const getOrderValue = (code) => {
            if (code === '65') return 0;
            if (code === '1') return 1;
            return 2;
          };

          const codeA = a.name.replace('+', '');
          const codeB = b.name.replace('+', '');

          const orderA = getOrderValue(codeA);
          const orderB = getOrderValue(codeB);

          if (orderA !== orderB) return orderA - orderB;
          return parseInt(codeA) - parseInt(codeB);
        });;
        let jobPosition = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "JobPosition");
        let Countries = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "Countries");
        // membershipArr.map(function (item) {
        //   delete item["dropdownName"];
        //   return item;
        // });
        // transactionArr.map(function (item) {
        //   delete item["dropdownName"]; return item;
        // });
        // billingCategoryArr.map(function (item) {
        //   delete item["dropdownName"]; return item;
        // });
        // membershipRevenueArr.map(function (item) {
        //   delete item["dropdownName"]; return item;
        // });
        // sourceArr.map(function (item) {
        //   delete item["dropdownName"]; return item;
        // });
        // userArr.map(function (item) {
        //   delete item["dropdownName"]; return item;
        // });
        this.setState(
          {
            membershipType: membershipType,
            membershipRevenue: membershipRevenue,
            countries: countries,
            serviceType: serviceType,
            industriesServed: industriesServed,
            getToKnow: getToKnow,
            associationBenefits: associationBenefits,
            mrMrs: mrMrs,
            designation: designation,
            years: years,
            emailCirculars: emailCirculars,
            billingCategories: billingCategories,
            transactionTypes: transactionTypes,
            applicationStatus: applicationStatus,
            totalGroupAssets: totalGroupAssets,
            ProjectDevelopmentTypes: ProjectDevelopmentTypes,
            countriesDailing: countriesDailingCode,
            jobPosition: jobPosition,
            committeeApprovalStatusList: CommitteeApprovalStatus,
            CountriesForCO: Countries,
            submissionTypeList: submissionType

          },
          () => {
            this.applyFilter();
          }
        );
      } else {
        this.swalServices.Error(response.message);
        this.getAllTaskList();
      }
      this.setState({ isLoading: false });
    });
  };

  getAllDropdownsForEndorsers(id) {
    this.corporateMemberServices.getAllDropdownsForEndorsers().then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let ordinaryEndorsers = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "AllEndorsers" || drp.dropdownName === "OrdinaryEndorsers");
        this.setState({ ordinaryEndorsers: ordinaryEndorsers });
        this.setState({ filterOrdinaryEndorsersList: ordinaryEndorsers });
      }
      if (response.statusCode === 200 && response.responseItem != null) {
        let allEndorsers = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "AllEndorsers" || drp.dropdownName === "OrdinaryEndorsers");
        allEndorsers = allEndorsers.filter((drp) => drp.id !== id);
        this.setState({ allEndorsers: allEndorsers });
        this.setState({ filterAllEndorsers: allEndorsers });
      }
    });
  }

  getRepresentativesById = (id, identity) => {

    this.corporateMemberServices.getRepresentativesById(id).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null && response.responseItem.responseContent.length > 0) {
        if (identity === "OrdinaryMembers") {
          let ordinaryRepresentative = response.responseItem.responseContent
          this.setState({ ordinaryRepresentative: ordinaryRepresentative });
        }
        if (identity === "AllMembers") {
          let allRepresentative = response.responseItem.responseContent
          this.setState({ allRepresentative: allRepresentative }
          );
        }
      } else {
        if (identity === "OrdinaryMembers") {
          this.setState({ ordinaryRepresentative: [] });
        }
        if (identity === "AllMembers") {
          this.setState({ allRepresentative: [] });
        }
      }
    });
  }

  getContactInformationDetailById = (id) => {
    if (id > 0 && id != null) {
      let request = [id]
      this.corporateMemberServices.getContactInformationDetailById(request).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let details = response.responseItem.responseContent;
          let taskDetails = this.state.taskDetails;
          taskDetails.contactInformationDetail = details
          this.setState({ taskDetails: taskDetails });
        }
        else {
          this.swalServices.Error(response.message);
        }

        this.setState({ isLoading: false });
      })
    }
  }


  generatePaymentInvoice = () => {
    let request = { ...this.state.taskDetails }
    this.corporateMemberServices.generatePaymentInvoice(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let taskDetails = response.responseItem.responseContent;

        // Merge new values with existing taskDetails
        // let taskDetails = {
        //   ...this.state.taskDetails,
        //   membershipPaymentInvoicePath: details.membershipPaymentInvoicePath
        // };
        // Update taskDetails in state
        this.setState({ taskDetails: taskDetails }, () => {
          this.addMembershipPaymentData();
        });
        this.getAllTaskList();
      }
      else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    })
  }

  getEndorsersEmailDetailById = (issendemail, ids) => {

    // if (ids === 1 && this.state.taskDetails.endorsementSatusForEndorser1 === 'Sent') {
    //   this.swalServices.Error("Email is Already Sent");
    //   return;
    // } else if (ids === 2 && this.state.taskDetails.endorsementSatusForEndorser2 === 'Sent') {
    //   this.swalServices.Error("Email is Already Sent");
    //   return;
    // }

    let requestData = {
      memberId: this.state.taskDetails.memberId,
      isSendEmail: true,
      typeId: ids,
      endorserId: 0,
      representativeId: 0,
    };

    if (requestData.memberId > 0 && requestData.memberId != null) {
      let detail = this.state.taskDetails;
      detail.isSendEmail = true;
      this.setState({ taskDetails: detail });

      if (issendemail === true && ids === 1) {
        requestData.endorserId = this.state.taskDetails.endorsersId1;
        requestData.representativeId = this.state.taskDetails.representativeId1;
        this.setState({ isLoadingSendMail1: true });
      } else if (issendemail === true && ids === 2) {
        requestData.endorserId = this.state.taskDetails.endorsersId2;
        requestData.representativeId = this.state.taskDetails.representativeId2;
        this.setState({ isLoadingSendMail2: true });
      }

      this.corporateMemberServices.getEndorsersEmailDetailById(requestData).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let details = response.responseItem.responseContent;
          let taskDetails = this.state.taskDetails;
          taskDetails.endorsementSatusForEndorser1 = response.responseItem.responseContent.endorsementSatusForEndorser1;
          taskDetails.endorsementSatusForEndorser2 = response.responseItem.responseContent.endorsementSatusForEndorser2;
          this.setState({ taskDetails: taskDetails }, () => {
            this.getEndorserHistoryLogDetailsByTaskId();
          });
        }
        else {
          this.swalServices.Error(response.message);
        }
        if (issendemail === true, ids === 1) {
          this.swalServices.Success("Email Sent Successfully to Endorser");
          this.setState({ isLoadingSendMail1: false })
        } else if (issendemail === true, ids === 2) {
          this.swalServices.Success("Email Sent Successfully to Endorser");
          this.setState({ isLoadingSendMail2: false })
        }
      })
    }
  }

  refreshTable = () => {
    // Fetch data again or perform any action to refresh the table
  }

  rejectApplicationForMember = () => {
    let audit = getAuditContext();

    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_Payment.replace("{0}", "Rejected"),
        CommonSuccessMessages.Reject.replace("{0}", "Reject Application Form"),
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (!response) return;

        let TaskId = this.state.taskDetails.taskId;
        if (TaskId > 0 && TaskId != null) {
          let detail = this.state.taskDetails;
          let request = { ...this.state.taskDetails }

          detail.isRejected = true;
          //let isRejected = true;
          this.setState({ taskDetails: detail })

          request.taskId = this.state.taskDetails.taskId;
          this.setState({ isLoadingReject: true });
          request.createdBy = audit.adminUserId;;
          request.createdAppId = audit.appId;
    
          this.setState({ isLoadingReject: true });
          this.TaskListServices.rejectApplicationForMember(request).then((response) => {

            if (response.statusCode === 200 && response.responseItem != null) {
              this.setState({ sendReject: true }, () =>
                this.setState({ setAddeditModalOpen: false })
              );
              window.location.reload();
            }
            else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isLoadingReject: true });
          })
        }
      });
  }

  getTaskByCompanyId = (taskid) => {

    this.TaskListServices.getTaskByCompanyId(taskid).then((response) => {

      if (response.statusCode === 200 && response.responseItem != null) {
        debugger
        response.responseItem.responseContent.transactionTypeId =
          response.responseItem.responseContent.transactionTypeId === null
            ? 1
            : response.responseItem.responseContent.transactionTypeId;
        let data = { ...this.state.taskDetails };
        let startdate = data.subscriptionStartDate != null ? moment(data.subscriptionStartDate).format("YYYY-MM-DD") : null;
        data.subscriptionStartDate = startdate;
        let enddate = data.subscriptionEndDate != null ? moment(data.subscriptionEndDate).format("YYYY-MM-DD") : null;
        data.subscriptionEndDate = enddate;
        let date = data.incorporationDate != null ? moment(data.incorporationDate).format("YYYY-MM-DD") : null;
        data.incorporationDate = date;

        let membershipCommitteeApprovalDetail = { ...this.state.membershipCommitteeApprovalDetails };
        membershipCommitteeApprovalDetail.taskId = response.responseItem.responseContent.taskId;
        membershipCommitteeApprovalDetail.companyName = response.responseItem.responseContent.companyName;
        membershipCommitteeApprovalDetail.corporateMemberID = response.responseItem.responseContent.corporateMemberId;
        membershipCommitteeApprovalDetail.comments = response.responseItem.responseContent.secreteriateCommentForMembershipCommittee;
        membershipCommitteeApprovalDetail.deadLineDate = response.responseItem.responseContent.membershipCommitteApprovalDeadLine;

        if (membershipCommitteeApprovalDetail.comments && membershipCommitteeApprovalDetail.deadLineDate) {
          this.state.membershipCommitteeInfoAvailable = true;
        }


        let companyProfile = { ...this.state.companyProfile };
        companyProfile.totalGroupAssetId = response.responseItem.responseContent.groupAssetId;

        const membershipType = this.state.membershipType.find(
          item => item.id === response.responseItem?.responseContent?.membershipTypeId
        );

        if (membershipType) {
          membershipCommitteeApprovalDetail.membershipType = membershipType.name;
        }
        let managementCommitteeApprovalDetail = { ...this.state.managementCommitteeApprovalDetails };
        managementCommitteeApprovalDetail.taskId = response.responseItem.responseContent.taskId;
        managementCommitteeApprovalDetail.companyName = response.responseItem.responseContent.companyName;
        managementCommitteeApprovalDetail.corporateMemberID = response.responseItem.responseContent.corporateMemberId;
        managementCommitteeApprovalDetail.comments = response.responseItem.responseContent.secreteriateCommentForManagementCommittee;
        managementCommitteeApprovalDetail.deadLineDate = response.responseItem.responseContent.managementCommitteApprovalDeadLine;

        if (managementCommitteeApprovalDetail.comments && managementCommitteeApprovalDetail.deadLineDate) {
          this.state.managementCommitteeInfoAvailable = true;
        }
        if (membershipType) {
          managementCommitteeApprovalDetail.membershipType = membershipType.name;
        }
        let managementCommitteeAdditionalDetail = { ...this.state.managementAdditionalInformationDetails }
        let membershipCommitteeAdditionalDetail = { ...this.state.membershipAdditionalInformationDetails }

        membershipCommitteeAdditionalDetail.taskId = response.responseItem.responseContent.taskId;
        membershipCommitteeAdditionalDetail.additionalNotes = response.responseItem.responseContent.membershipCommitteeAdditionalNotes;
        membershipCommitteeAdditionalDetail.additionalDate = response.responseItem.responseContent.membershipCommitteeApprovalDate;
        if (membershipCommitteeAdditionalDetail.additionalNotes && membershipCommitteeAdditionalDetail.additionalDate) {
          this.state.isMembershipCommitteeadditionalInfo = true;
        }

        managementCommitteeAdditionalDetail.taskId = response.responseItem.responseContent.taskId;
        managementCommitteeAdditionalDetail.additionalNotes = response.responseItem.responseContent.managementCommitteeAdditionalNotes;
        managementCommitteeAdditionalDetail.additionalDate = response.responseItem.responseContent.managementCommitteeApprovalDate;

        if (managementCommitteeAdditionalDetail.additionalNotes && managementCommitteeAdditionalDetail.additionalDate
          && managementCommitteeAdditionalDetail.additionalNotes != '' && managementCommitteeAdditionalDetail.additionalDate != ''
          && managementCommitteeAdditionalDetail.additionalNotes != null && managementCommitteeAdditionalDetail.additionalDate != null) {
          this.state.isManagementCommitteeadditionalInfo = true;
        }
        let welcomeletter = response.responseItem.responseContent.welcomecontent
        this.setState({
          selfDeclarationComment: response.responseItem.responseContent.isSelfComment ? "Yes" : "No",
          isSelfComment: response.responseItem.responseContent.isSelfComment ? 1 : 0,
          selfDeclaration: response.responseItem.responseContent.selfDeclaration || ""
        });


        this.setState({ membershipCommitteeApprovalDetails: membershipCommitteeApprovalDetail, managementCommitteeApprovalDetails: managementCommitteeApprovalDetail, managementAdditionalInformationDetails: managementCommitteeAdditionalDetail, membershipAdditionalInformationDetails: membershipCommitteeAdditionalDetail })
        this.setState({ isMCApprovalSubmitted: response.responseItem.responseContent.isMembershipCommitteeApprovalSubmitted })
        this.setState({ companyProfile: companyProfile })
        this.setState({ welcomeletter: welcomeletter })
        this.setState({ statusId: response.responseItem.responseContent.statusId })

        this.setState(
          { taskDetails: response.responseItem.responseContent },

          () => this.setState({ validState: { isValid: true, error: {} } })
        );
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
      this.getAllBODAndTopMangementByTaskId(taskid);
      this.getAllCorporateMemberProjectsByTaskId(taskid);
      this.getAllRepresentativesByTaskId(taskid);
      this.GetCommitteeApprovalHistoryLogsById(taskid);
    });
  };
  getAllBODAndTopMangementByTaskId = (taskid) => {
    this.TaskListServices.getAllBODAndTopMangementByTaskId(taskid).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let boardDirector = response.responseItem.responseContent.filter(
          (item) => item.isBoardOfDirectors === true
        );
        let topManagement = response.responseItem.responseContent.filter(
          (item) => item.isBoardOfDirectors === false
        );
        this.setState({ boardAndTopMtgList: response.responseItem.responseContent });
        this.setState({ boardDirectorList: boardDirector });
        this.setState({ topManagementList: topManagement });
      } else {
        this.swalServices.Warning("Records not found", "Ok");
      }
    })
  }
  getAllCorporateMemberProjectsByTaskId = (taskid) => {
    this.TaskListServices.getAllCorporateMemberProjectsByTaskId(taskid).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let projectCompletedList = response.responseItem.responseContent.filter(
          (item) => item.isProjectCompleted === true
        );
        let projectsInProgress = response.responseItem.responseContent.filter(
          (item) => item.isProjectCompleted === false
        );
        this.setState({ ordinaryMainProjectList: response.responseItem.responseContent });
        this.setState({ ordinaryProjectsCompletedList: projectCompletedList });
        this.setState({ ordinaryProjectsInCompleteList: projectsInProgress });
      }

    })
  }

  getAllRepresentativesByTaskId = (taskid) => {
    this.TaskListServices.getAllRepresentativesByTaskId(taskid).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let representative = response.responseItem.responseContent.filter(
          (item) => item.isMainRepresentative === true
        );
        let alternateRepresentative = response.responseItem.responseContent.filter(
          (item) => item.isMainRepresentative === false
        );

        this.setState({
          representativeDetails: representative,
          alternativeRepresentative: alternateRepresentative,
        });
      }
    })
  }


  deleteMembershipTaskList = (value) => {
    let request = {
      id: value,
      deletedBy: 1,
      appId: 115
    }
    this.swalServices.Confirm(CommonSuccessMessages.Confirm_Question.replace("{0}", "Member"), CommonSuccessMessages.Confirm_Delete.replace("{0}", "Member"),
      CommonSuccessMessages.Yes_Text, CommonSuccessMessages.No_Text).then((response) => {
        if (response) {
          this.TaskListServices.deleteMembershipTaskList(request).then((response) => {
            if (response.statusCode === 200) {
              this.swalServices.Success("Deleted");
              this.getAllTaskList();
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
          });
        }
      });
  }


  getEndorserHistoryLogDetailsByTaskId = () => {
    let request = this.state.taskDetails.taskId;
    this.corporateMemberServices.getEndorserHistoryLogDetailsByTaskId(request).then((response) => {

      if (response.statusCode === 200 && response.responseItem != null) {
        let historyLogDetail = response.responseItem.responseContent
        this.setState({ historyLogDetail: historyLogDetail });
      }
      else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    })
  }

  setSendClarificationsFlag = () => {
    this.setState({ setSendClarifications: true });
  }
  setWelcomeletterFlag = () => {
    this.setState({ setWelcomeletter: true });
  }
  handleChangeClarificationDetails = (data) => {
    if (typeof data === "string") {
      this.setState({
        clarification: data,
      });
    }
  };
  handleChangeWelcomeletterDetails = (data) => {
    if (typeof data === "string") {
      this.setState({
        welcomeletter: data,
      });
    }
  };
  saveClarificationDetails = () => {
    let audit = getAuditContext();

    if (!this.state.representativeDetails.length) {
      this.swalServices.Error("No main representative found.");
      this.setState({ setSendClarifications: false });
      return;
    }
    this.setState({ setSendClarifications: true });
    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_SendClarifications.replace(
          "{0}",
          "Admin"
        ),
        "",
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      ).then((response) => {
        if (response) {
          let request = { ...this.state.sendClarificationMail }
          request.taskId = this.state.taskDetails.taskId
          request.corporatememberId = this.state.representativeDetails[0].corporateMemberId
          request.companyName = this.state.taskDetails.companyName
          request.companyUEN = this.state.taskDetails.companyUEN
          request.mainRepresentativeName = this.state.representativeDetails[0].firstName
          request.salutation = this.state.representativeDetails[0].salutation
          request.mainRepresentativeEmail = this.state.representativeDetails[0].bussinessEmail
          request.subscriptionStartDate = this.state.taskDetails.subscriptionStartDate === "Invalid date" ? moment(new Date()) : this.state.taskDetails.subscriptionStartDate
          request.isRejected = this.state.taskDetails.isRejected === undefined ? 0 : this.state.taskDetails.isRejected
          request.clarificationDetails = this.state.clarification
          request.createdBy = audit.adminUserId;;
          request.createdAppId = audit.appId;

          this.setState({ isLoadingClarification: true });
          this.TaskListServices.saveClarificationDetails(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
              this.setState({ setSendClarifications: false });
              this.setState({ clarification: "" });
              this.setState({ sendEscalation: true }, () =>
                this.setState({ setAddeditModalOpen: false })
              );
            } else {
              this.swalServices.Error(response.message);
            }
            this.setState({ isLoadingClarification: false });
          });
        } else {
          this.setState({ isLoading: false });
          this.setState({ setSendClarifications: false });
        }
      });
  };
  saveWelcomeLetterDetail = () => {


    this.setState({ setWelcomeletter: true });

    let request = {}
    request.taskId = this.state.taskDetails.taskId
    request.welcomecontent = this.state.welcomeletter
    if (request.taskId !== null) {

      this.setState({ isLoadingWelcomeDetail: true });
      this.TaskListServices.saveWelcomeLetterDetail(request).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.setState({ setWelcomeletter: false });
          this.swalServices.Success("Welcome letter detail updated successfully.");
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoadingWelcomeDetail: false });
      });
    }
    else {
      this.setState({ isLoading: false });
      this.setState({ setWelcomeletter: false });
    }
    ;
  };
  sendPaymentLink = () => {


    var TotalGroupAssetId = this.state.taskDetails.groupAssetId;

    if (this.state.taskDetails.membershipTypeId === 2) {
      if (TotalGroupAssetId > 0 || TotalGroupAssetId != 0 || TotalGroupAssetId != null) {
        this.swalServices
          .Confirm(
            CommonSuccessMessages.Confirm_Payment.replace("{0}", "Payment Link"),
            CommonSuccessMessages.Send_Payment_Link.replace("{0}", "Payment Link"),
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text
          )
          .then((response) => {
            if (!response) return;
            this.setState({ isLoadingPayment: true });

            // Retrieve & clean necessary data
            const updatedTopManagements = this.state.topManagementList?.map(({ isEditing, ...rest }) => rest) ?? [];
            const updatedDirectors = this.state.boardDirectorList?.map(({ isEditing, ...rest }) => rest) ?? [];

            const request = {
              ...this.state.welcomeletter,
              ...this.state.taskDetails,
              ...this.state.companyProfile,
              representativeDetails: [
                ...(this.state.representativeDetails ?? []),
                ...(this.state.alternativeRepresentative ?? [])
              ],
              directorsManagementObj: [
                ...updatedDirectors,
                ...updatedTopManagements
              ],
              projectsObj: [
                ...(this.state.projects ?? []),
                ...(this.state.inProgressProjects ?? [])
              ],

            };

            let details = this.state.taskDetails
            // if (details.isCOForBiilingChecked) {
            if (
              !details.billingEntity.trim() ||
              !details.billingAttention.trim() ||
              !details.billingEmailAddress.trim() ||
              !details.billingAddress.trim() ||
              !details.billingPostalCode.trim() ||
              !details.billingCountryI === 0 ||
              details.attentionSalutationId === 0
            ) {
              this.swalServices.Error("Please write C/O Billing information.");
              this.setState({ isLoadingPayment: false });

              return;
            }
            // }

            if (request) {
              this.TaskListServices.AddEditMembershipTask(request).then((response) => {

                if (response.statusCode === 200 && response.responseItem) {

                  if (response.statusCode === 200 && response.responseItem) {
                    this.swalServices.Success(
                      "Payment Link Send Successfully "
                    );
                  }
                  this.setState({ isLoadingPayment: false });

                  this.TaskListServices.GenerateMembershipPaymentInvoiceAndSendPaymentLink(request).then((response) => {

                  })
                  // Navigate(Routes.home)
                } else {
                  this.setState({ isLoadingPayment: false });

                  this.swalServices.Error(response.message);
                }
              })
            }
          });
      }
      else {
        this.swalServices.Error("Please Select Group Asset.");
      }
    } else {

      if (TotalGroupAssetId > 0 && TotalGroupAssetId != 0 && TotalGroupAssetId != null) {
        this.swalServices
          .Confirm(
            CommonSuccessMessages.Confirm_Payment.replace("{0}", "Payment Link"),
            CommonSuccessMessages.Send_Payment_Link.replace("{0}", "Payment Link"),
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text
          )
          .then((response) => {
            if (!response) return;
            this.setState({ isLoadingPayment: true });

            // Retrieve & clean necessary data
            const updatedTopManagements = this.state.topManagementList?.map(({ isEditing, ...rest }) => rest) ?? [];
            const updatedDirectors = this.state.boardDirectorList?.map(({ isEditing, ...rest }) => rest) ?? [];

            const request = {
              ...this.state.taskDetails,
              ...this.state.companyProfile,
              representativeDetails: [
                ...(this.state.representativeDetails ?? []),
                ...(this.state.alternativeRepresentative ?? [])
              ],
              directorsManagementObj: [
                ...updatedDirectors,
                ...updatedTopManagements
              ],
              projectsObj: [
                ...(this.state.projects ?? []),
                ...(this.state.inProgressProjects ?? [])
              ]
            };

            let details = this.state.taskDetails


            if (details.isCOForBiilingChecked) {
              if (
                !details.billingEntity?.trim() ||
                !details.billingAttention?.trim() ||
                !details.billingEmailAddress?.trim() ||
                details.attentionSalutationId === 0
              ) {
                this.swalServices.Error("Please write C/O Billing information.");
                this.setState({ isLoadingPayment: false });
                return;
              }
            }

            request.welcomeContent = this.state.welcomeletter

            if (request) {
              this.TaskListServices.AddEditMembershipTask(request).then((response) => {

                if (response.statusCode === 200 && response.responseItem) {

                  if (response.statusCode === 200 && response.responseItem) {
                    this.swalServices.Success(
                      "Payment Link Send Successfully "

                    );

                  }
                  this.setState({ isLoadingPayment: false });

                  this.TaskListServices.GenerateMembershipPaymentInvoiceAndSendPaymentLink(request).then((response) => {

                  })
                  // Navigate(Routes.home)
                } else {
                  this.setState({ isLoadingPayment: false });

                  this.swalServices.Error(response.message);
                }
              })
            }
          });
      }
      else {
        this.swalServices.Error("Please Select Group Asset.");
      }
    }

  }

  componentDidUpdate() {
    console.log(this.state.taskDetails)
  }


  // sendClarificationMailToMember = () => {
  //   var request = this.state.sendEscalate;
  //   request.firstName = this.state.taskDetails.contactInformationDetail.firstName;
  //   request.lastName = this.state.taskDetails.contactInformationDetail.lastName;
  //   request.companyName = this.state.taskDetails.organisationName;
  //   request.companyUEN = this.state.taskDetails.organisationUEN;
  //   request.generalEmailAddress = this.state.taskDetails.generalEmailAddress;
  //   request.contactNo = 12;
  //   request.internalNotes = "Internal Notes";
  //   this.setState({ isLoadingClarification: true });

  //   this.TaskListServices.sendClarificationMailToMember(request).then((response) => {
  //     if (response.statusCode === 200 && response.responseItem != null) {
  //       this.setState({ sendEscalation: true }, () =>
  //         this.setState({ setAddeditModalOpen: false })
  //       );
  //     } else {
  //       this.swalServices.Error(response.message);
  //     }
  //     this.setState({ isLoadingClarification: false });
  //   });
  // };

  // sendPaymentLink = () => {

  //   this.swalServices
  //     .Confirm(
  //       CommonSuccessMessages.Confirm_Payment.replace("{0}", "Payment Link"),
  //       CommonSuccessMessages.Send_Payment_Link.replace("{0}", "Payment Link"),
  //       CommonSuccessMessages.Yes_Text,
  //       CommonSuccessMessages.No_Text
  //     )
  //     .then((response) => {
  //       let resp = response;
  //       if (resp === true) {

  //         let topManagements = [...this.state.topManagementList];
  //         let directors = [...this.state.boardDirectorList];


  //         const updatedTopManagements = topManagements.map(({ isEditing, ...rest }) => rest);
  //         const updatedDirectors = directors.map(({ isEditing, ...rest }) => rest);

  //         let taskDetail = { ...this.state.taskDetails };


  //         const request = {

  //           ...taskDetail,
  //           representativeDetails: this.state.representativeDetails || [],
  //           ...this.state.companyProfile,

  //           directorsManagementObj: [
  //             ...(Array.isArray(updatedDirectors) ? updatedDirectors : []),
  //             ...(Array.isArray(updatedTopManagements) ? updatedTopManagements : [])
  //           ],
  //           projectsObj: [
  //             ...(Array.isArray(this.state.projects) ? this.state.projects : []),
  //             ...(Array.isArray(this.state.inProgressProjects) ? this.state.inProgressProjects : [])
  //           ]

  //         }

  //         if (request) {
  //           this.TaskListServices.AddEditMembershipTask(request).then((response) => {

  //             if (response.statusCode === 200 && response.responseItem != null) {
  //               this.swalServices.Success(
  //                 "Corporate members added succefully"
  //               );
  //               Navigate(Routes.home)
  //             } else {
  //               this.swalServices.Error(response.message);
  //             }
  //           })
  //         }
  //       }
  //     });
  // };

  addMembershipPaymentData = () => {
    let request = { ...this.state.taskDetails };
    request.corporateId = this.state.taskDetails.memberId
    request.taskId = this.state.taskDetails.taskId;
    request.finalCalculatedPriceId = this.state.taskDetails.finalCalculatedPriceId;
    request.entranceFee = this.state.taskDetails.entranceFee;
    request.subscriptionFee = this.state.taskDetails.subscriptionFee;
    request.subTotalAmount = this.state.taskDetails.subtotalPrice;
    request.gSTAmount = this.state.taskDetails.gstPrice;
    request.discountedAmount = this.state.taskDetails.discountedPrice;
    request.totalAmount = this.state.taskDetails.totalPrice;
    request.invoicePath = this.state.taskDetails.invoicePath;
    request.paymentVia = this.state.taskDetails.paymentVia;
    request.paymentStatus = this.state.taskDetails.paymentStatus;

    request.paymentsCreditsApplied = this.state.taskDetails.paymentsCreditsApplied;
    request.transactionId = this.state.taskDetails.transactionId;
    request.membershipPaymentTypeId = this.state.taskDetails.membershipPaymentTypeId;
    request.voucherCode = this.state.taskDetails.voucherCode;

    request.gstRate = this.state.taskDetails.gstRate;


    request.paymentStatus = 'Pending';
    request.membershipTenureId = 1;
    request.createdAt = new Date();
    request.createdBy = this.state.corporateMemberId;
    request.createdAppId = 115;
    request.paymentDescription = "New membership payment";
    request.membersReceiptId = this.state.taskDetails.membersReceiptId;
    request.membershipPaymentInvoicePath = this.state.taskDetails.membershipPaymentInvoicePath ? this.state.taskDetails.membershipPaymentInvoicePath : 'invoicepath';

    this.TaskListServices.addMembershipPaymentData(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem.responseContent != null) {
        let taskDetails = response.responseItem.responseContent;
        this.setState({ taskDetails: taskDetails })
      } else {
        this.swalServices.Error(response.message);
        this.setState({ isProceedPayment: false });
      }
      this.setState({ isLoading: false });
    })
  }

  addEditTask = () => {
    let request = { ...this.state.taskDetails }
    this.TaskListServices.addEditTask(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        this.setState({ setAddeditModalOpen: false }, () =>
          this.getAllTaskList()
        );
        this.swalServices.Success("Details Add Successfully..")
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoadingApprove: false });
    });
  }

  approveRenewMembershipRequest = (
    bookingId,
    corporateId,
    paymentCategoryId,
    financeAdhocInvoiceId
  ) => {

    this.setState({ isLoadingApproveRenew: true });
    if (paymentCategoryId === 3) {
      let acceptTotalMembershipRequest = {};
      if (this.state.taskDetails.approvalDate === undefined || this.state.taskDetails.approvalDate === "" || this.state.taskDetails.approvalDate === null) {
        let currentDate = moment(new Date()).format("yyyy-MM-DD");
        acceptTotalMembershipRequest.approvalDate = currentDate;
      }
      else {
        acceptTotalMembershipRequest.approvalDate = this.state.taskDetails.approvalDate
      }
      acceptTotalMembershipRequest.MemberId = corporateId;
      acceptTotalMembershipRequest.membershipPaymentTypeId = paymentCategoryId;
      acceptTotalMembershipRequest.membershipPaymentId = bookingId;

      this.BookingServices.approveAndUpdatePaymentHistoryForRenewMembershipPayment(acceptTotalMembershipRequest).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          if (response.responseItem.responseContent != null) {
            this.setState({ setpaymentApprovalModalOpen: false });
            this.swalServices.Success(
              "Renewal Application Approved successfully."
            );
            this.setState({ route: "/Membership/MembershipRenewalDashboard" })
            this.setState({ isLoadingApproveRenew: false });
          }
        } else {
          this.swalServices.Error(response.message);
        }

      });
    }
  };

  addEditMembershipTaskAndSendPaymentLink = () => {
    if (this.isValidateAllFields) {
      var pricingList = [];
      var request = { ...this.state.taskDetails, ...pricingList };
      request.taskId = this.state.taskDetails.taskId;
      request.memberId = this.state.taskDetails.memberId;
      request.contactRoleId = this.state.taskDetails.contactRoleId;
      request.IsApprovalRequired = true;
      request.IsPaymentLinkSent = false;
      request.generalEmailAddress = request.generalEmailAddress
      request.billingCategoryId = request.billingCategoryId ? request.billingCategoryId : 1
      request.statusId = 9
      request.contactInformationDetail = this.state.taskDetails.contactInformationDetail
      request.membershipPaymentInvoicePath = this.state.taskDetails.membershipPaymentInvoicePath;

      //start end date conditions
      var currentDate = new Date();
      request.subscriptionEndDate = request.transactionTypeId === 3 ? new Date(currentDate.getFullYear() + 1, 11, 32) : new Date(currentDate.getFullYear(), 11, 32);
      request.subscriptionEndDate.setHours(0, 0, 0, 0);
      this.setState({ isLoadingApprove: true });

      request.contactInformationDetail = this.state.taskDetails.contactInformationDetail
      request.membershipPaymentInvoicePath = this.state.taskDetails.membershipPaymentInvoicePath;
      request.subscriptionStartDate = this.state.taskDetails.approvalDate;

      if (this.state.taskDetails.approvalDate === undefined || this.state.taskDetails.approvalDate === "" || this.state.taskDetails.approvalDate === null) {
        let currentDate = new Date();
        request.approvalDate = currentDate;
        request.subscriptionStartDate = currentDate;
      }

      if (this.state.taskDetails.committeeApprovalDate === undefined || this.state.taskDetails.committeeApprovalDate === "" || this.state.taskDetails.committeeApprovalDate === null) {
        let currentDate = new Date();
        request.committeeApprovalDate = currentDate;
      }

      this.setState({ isLoadingApprove: true });
      this.TaskListServices.addEditMembershipTaskAndSendPaymentLink(request).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let id = response.responseItem.responseContent.keyId
          let taskDetails = this.state.taskDetails
          // taskDetails.taskId = id
          this.setState({ taskDetails: taskDetails }, () => {
            // this.generatePaymentInvoice();
          })
          this.setState({ setPaymentLink: true }, () =>
            this.setState({ setAddeditModalOpen: false })
          );
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoadingApprove: false });
      });
    }
    // }
  };




  GetCommitteeApprovalHistoryLogsById = (taskId) => {
    this.TaskListServices.GetCommitteeApprovalHistoryLogsById(taskId).then((response) => {

      if (response.statusCode === 200 && response.responseItem?.responseContent) {
        const { responseContent } = response.responseItem;

        const membershipCommitteeApproval = responseContent.filter(item => item.isMembershipCommitteeApproval);
        const managementCommitteeApproval = responseContent.filter(item => !item.isMembershipCommitteeApproval);

        if (membershipCommitteeApproval.length || managementCommitteeApproval.length) {
          this.setState({ membershipCommitteeApproval, managementCommitteeApproval });
        }
      }
    })
  }

  addEditReinstatementPaymentDataAndSendPaymentLink = () => {
    if (this.isValidateAllFields) {
      var pricingList = [];
      var request = { ...this.state.taskDetails, ...pricingList };
      request.taskId = this.state.taskDetails.taskId;
      request.memberId = this.state.taskDetails.memberId;
      request.contactRoleId = this.state.taskDetails.contactRoleId;
      request.IsApprovalRequired = true;
      request.IsPaymentLinkSent = false;
      request.generalEmailAddress = request.generalEmailAddress
      request.billingCategoryId = request.billingCategoryId ? request.billingCategoryId : 1
      request.statusId = 9
      request.contactInformationDetail = this.state.taskDetails.contactInformationDetail
      request.membershipPaymentInvoicePath = this.state.taskDetails.membershipPaymentInvoicePath;

      request.reinstatementStartDate = this.state.taskDetails.reinstatementStartDate;
      request.reinstatementEndDate = this.state.taskDetails.reinstatementEndDate;

      if (this.state.taskDetails.committeeApprovalDate === undefined || this.state.taskDetails.committeeApprovalDate === "" || this.state.taskDetails.committeeApprovalDate === null) {
        let currentDate = new Date();
        request.committeeApprovalDate = currentDate;
      }

      this.setState({ isLoadingApprove: true });
      this.TaskListServices.addEditReinstatementPaymentDataAndSendPaymentLink(request).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let id = response.responseItem.responseContent.keyId
          let taskDetails = this.state.taskDetails
          this.setState({ taskDetails: taskDetails });
          this.setState({ setPaymentLink: true }, () =>
            this.setState({ setAddeditModalOpen: false }),
            this.getAllTaskList()
          );
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoadingApprove: false });
      });
    }
    // }
  };

  isValidateAllFields = () => {

    const newValidState = isValidForm(
      this.state.taskDetails,
      this.state.validationRule,
      this.state.validState,
      this.state.membershipCommitteeApprovalDetails,
      this.state.managementCommitteeApprovalDetails
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;

  };
  isValidateAllFieldsForApproval = (isMembership) => {


    if (isMembership) {
      var newValidState = isValidForm(
        this.state.membershipCommitteeApprovalDetails,
        this.state.validationRuleForMembership,
        this.state.validState
      );
      this.setState({ validState: newValidState });
      return newValidState.isValid;

    }
    if (!isMembership) {
      var newValidState = isValidForm(
        this.state.managementCommitteeApprovalDetails,
        this.state.validationRuleForManagement,
        this.state.validStateForManagement
      );
      this.setState({ validStateForManagement: newValidState });
      return newValidState.isValid;

    }
  };


  validateFieldForMembership = (key) => {
    const newValidState = validate(
      key,
      this.state.membershipCommitteeApprovalDetails,
      this.state.validationRuleForMembership,
      this.state.validState
    );
    this.setState({ validState: newValidState });
  };
  validateFieldForManagement = (key) => {

    const newValidState = validate(
      key,
      this.state.managementCommitteeApprovalDetails,
      this.state.validationRuleForManagement,
      this.state.validStateForManagement
    );
    this.setState({ validStateForManagement: newValidState });
  };


  validateField = (key) => {
    const newValidState = validate(
      key,
      this.state.taskDetails,
      this.state.validationRule,
      this.state.validState
    );
    this.setState({ validState: newValidState });
  };

  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination });
    this.getAllTaskList(newPagination);
  };

  setFilterParameters = (id, drpIdentity) => {
    let detail = this.state.taskDetails;
    let companydetail = this.state.companyProfile;
    let alternativeRep = this.state.alternativeRepresentative[0]
    let mainRep = this.state.representativeDetails[0]

    let representativesDetail = this.state.representatives;
    if (drpIdentity === "MembershipType") {
      detail["membershipTypeId"] = id;
      this.validateField("membershipTypeId");
    }
    if (drpIdentity === "BillingCategories") {
      detail["billingCategoryId"] = id;
      //this.validateField("billingCategoryId");
    }
    if (drpIdentity === "AssociationBenefits") {
      detail["associationBenefitsId"] = id;
      this.validateField("associationBenefitsId");
    }
    if (drpIdentity === "AttentionSalutation") {
      detail["attentionSalutationId"] = id;
      //this.validateField("associationBenefitsId");
    }
    //Endorsers
    if (drpIdentity === "OrdinaryEndorsers") {
      detail["endorsersId1"] = id;
      // this.getAllDropdownsForEndorsers(id);
      this.getRepresentativesById(id, "OrdinaryMembers");
      this.validateField("endorsersId1");
    }
    if (drpIdentity === "AllEndorsers") {

      detail["endorsersId2"] = id;
      this.getRepresentativesById(id, "AllMembers");
      this.validateField("endorsersId2");
    }
    if (drpIdentity === "OrdinaryRepresentatives") {
      let ordinaryRepresentative1 = this.state.ordinaryRepresentative.find(rep => rep.id === id);
      detail["representativeId1"] = ordinaryRepresentative1 ? ordinaryRepresentative1.id : null;
      this.validateField("representativeId1");
    }
    if (drpIdentity === "AllRepresentatives") {
      let allRepresentative1 = this.state.allRepresentative.find(rep => rep.id === id);
      detail["representativeId2"] = allRepresentative1 ? allRepresentative1.id : null;
      this.validateField("representativeId2");
    }
    if (drpIdentity === "totalGroupAssets") {
      detail["groupAssetId"] = id;
      //this.validateField("groupAssetId");
    }

    if (drpIdentity === "jobFunctionsRep1") {
      representativesDetail['jobPosition'] = id;
      // this.setState(
      //   { representatives: { ...representativesDetail } }, 
      //   () => this.validateFieldsForRepresentative1("jobPosition")
      // );
    }

    if (drpIdentity === "Salutation1") {
      mainRep["salutation"] = id;
    }
    if (drpIdentity === "Salutation2") {
      alternativeRep["salutation"] = id;
    }
    if (drpIdentity === "CountriesDailingCode1") {
      mainRep["countryDialingCodeID"] = id;
    }
    if (drpIdentity === "CountriesDailingCode2") {
      alternativeRep["countryDialingCodeID"] = id;
    }
    if (drpIdentity === "JobPosition1") {
      mainRep["jobPosition"] = id;
    }
    if (drpIdentity === "JobPosition2") {
      alternativeRep["jobPosition"] = id;
    }
    if (drpIdentity === "CountriesForCO") {
      detail["billingCountryId"] = id;
    }



    this.setState((prev) => {
      const newState = {
        taskDetails: detail,
        representativeDetails: [
          mainRep,
          ...prev.representativeDetails.slice(1),
        ],
      }

      if (alternativeRep) {
        newState.alternativeRepresentative = [
          alternativeRep,
          ...prev.alternativeRepresentative.slice(1),
        ]
      }

      return newState;
    })


  };

  setFilterParametersForDesignation = (index, fieldName, id, drpIdentity) => {
    const { taskDetails } = this.state;
    let updatedContactInfo = [...taskDetails.contactInformationDetail];

    if (updatedContactInfo[index]) {
      updatedContactInfo[index] = {
        ...updatedContactInfo[index],
        [fieldName]: id
      };

      // if (drpIdentity === "DesignationFirst") {
      //   let detail = this.state.taskDetails;
      //   detail["designationId"] = id;
      // }
      // if (drpIdentity === "DesignationCEO") {
      //   let detail = this.state.taskDetails;
      //   detail["designationId"] = id;
      // }
      this.setState({
        taskDetails: {
          ...taskDetails,
          contactInformationDetail: updatedContactInfo
        }
      });
    }
  };


  handleChangeDropdown = (index, fieldName, value) => {
    const { taskDetails } = this.state;
    let updatedContactInfo = [...taskDetails.contactInformationDetail];
    updatedContactInfo[index] = {
      ...updatedContactInfo[index],
      [fieldName]: value
    };

    this.setState({
      taskDetails: {
        ...taskDetails,
        contactInformationDetail: updatedContactInfo
      }
    });
  };

  // setFilterParametersForList = (id, drpIdentity) => {
  //   let detail = this.state.pagination;
  //   if (drpIdentity === "ApplicationStatus") {
  //     detail["filterByStatus"] = id;
  //   }
  //   this.setState({ pagination: { ...detail } });
  //   this.getAllTaskList();
  // };

  searchByName = (value) => {
    let detail = this.state.pagination;
    detail.searchText = "";
    this.setState({ pagination: { ...detail } });
    if (value.length > 2) {
      detail.pageNo = 1;
      detail.pageSize = 10;
      detail.searchText = value;
      this.setState({ pagination: { ...detail } });
    }
    this.getAllTaskList();
  };

  handleChangeForPagination(event) {
    const value = event.target.value;
    const name = event.target.name;
    let detail = this.state.pagination;
    let fulldate = (detail[name] = value === "" ? null : value);
    let date = new Date(fulldate); //1/1/1753 12:00:00 AM and 12/31/9999 11:59:59 PM
    let startLimit = new Date("1/1/1753 12:00:00 AM");
    let endLimit = new Date("12/31/9999 11:59:59 PM");
    detail[name] = value;
    this.setState({ pagination: { ...detail } }, () => {
      if (startLimit < date && date < endLimit) {
        this.getAllTaskList();
      } else if (fulldate === null) {
        this.getAllTaskList();
      }
    });
  }


  handleChangeForCompanyInformation(event) {
    const value = event.target.value;
    const name = event.target.name;
    let companyInformationDetails = this.state.companyInformation;
    companyInformationDetails[name] = value;
    this.setState({ companyInformation: { ...companyInformationDetails } });
  }


  handleChange(event, identity) {

    const { name, value } = event.target;

    // Copy the state arrays
    let representativeDetails = [...this.state.representativeDetails];
    let alternativeRepresentative = [...this.state.alternativeRepresentative];
    let taskDetails = { ...this.state.taskDetails };

    // Update representativeDetails (Main Representative)

    if (identity === "rep") {
      if (representativeDetails.length > 0) {
        representativeDetails[0] = { ...representativeDetails[0], [name]: value };
      } else {
        representativeDetails.push({ [name]: value });
      }
    }
    else if (identity === "alterRep") {
      // Update alternativeRepresentative (Alternate Representative)
      if (alternativeRepresentative.length > 0) {
        alternativeRepresentative[0] = { ...alternativeRepresentative[0], [name]: value };
      } else {
        alternativeRepresentative.push({ [name]: value });
      }
    }

    // Update taskDetails
    taskDetails[name] = value;

    // Set state with updated values
    this.setState({
      representativeDetails,
      alternativeRepresentative,
      taskDetails
    });
  }



  // handleChange(event) {
  //   const value = event.target.value;
  //   const name = event.target.name;
  //   let detail = this.state.taskDetails;
  //   detail[name] = value;

  //   this.setState({ taskDetails: { ...detail } }, () => {


  //   })

  //   // this.setState({ taskDetails: { ...detail } }, () => {
  //   //   // Your existing logic for other fields...

  //   //   // Check if the changed field is 'approvalDate'
  //   //   if (name === "approvalDate") {
  //   //     // Create a request object with only the 'approvalDate' field
  //   //     let request = {
  //   //       approvalDate: value
  //   //     };

  //   //     // Call the API with the updated 'approvalDate' field
  //   //     this.TaskListServices.addEditMembershipTaskAndSendPaymentLink(request)
  //   //       .then((response) => {
  //   //         if (response.statusCode === 200 && response.responseItem != null) {
  //   //           //console.log("Approval date updated successfully");
  //   //         }
  //   //       })
  //   //       .catch((error) => {
  //   //         console.error("Error updating approval date:", error);
  //   //       });
  //   //   }
  //   // });
  // }

  onDropDownChange = (index) => {
    this.setState({ setDropdownOpen: true });
    this.setState({ setDropdownIndex: index });
  };

  selectTask = (value, e) => {
    e.stopPropagation();
    this.setState({ setAddeditModalOpen: true, selectedTaskId: value },
      this.getTaskByCompanyId(value),

    );
  };

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ setDropdownOpen: false });
    }
  }

  actionClick = (index, value, option, event) => {
    if (option === "Process") {
      var id = this.state.taskList[index].taskId;
      this.setState(
        { selectedTaskId: this.state.taskList[index].taskId },
        () => {
          this.selectTask(id, event);
        }
      );
    } else if (option === "Delete") {
      this.deleteMembershipTaskList(value);
    }
  };

  deleteTaskListDetailsByTaskId = (companyId) => {
    this.TaskListServices.deleteTaskListDetailsByTaskId(companyId).then(
      (response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.swalServices.Success(
            "Membership Task List Entry Deleted Successfully."
          );
          let resetpag = {
            pageNo: 1,
            pageSize: 10,
            orderByColumn: "",
            orderFlag: 0,
            searchText: "",
            status: 0,
            dateFrom: null,
            dateTo: null,
            filterByStatus: 0,
          };
          this.setState({ pagination: resetpag }, () => {
            this.getAllTaskList();
          });
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      }
    );
  };

  actions = (element, index, value) => {
    return element !== "taskId" ? null : (
      <td>
        <ActionContainer>
          <DropdownAction
            key={index}
            value={value}
            id={index}
            index={index}
            options={this.state.actionDropdown}
            align="right"
            onOptionClick={this.actionClick.bind(this)}
          />
        </ActionContainer>
      </td>
    );
  };

  onProcessModalClose = (e) => {
    e.stopPropagation();
    this.setState({ setAddeditModalOpen: false });
  };

  // For Opens in the New tab
  updateCorporateMemberUpdate = (value) => {
    if (value && value > 0) {
      const encryptedValue = encryptAES(value);
      const newUrl = '/CreateCorporateMembers/CorporateMemberId?=' + encryptedValue;
      window.open(newUrl, '_blank');
    }
  }

  // For Opens in the same tab

  updateCorporateMemberUpdate = (value) => {
    if (value && value > 0) {
      const encryptedValue = encryptAES(value);
      const newUrl = '/CreateCorporateMembers/CorporateMemberId?=' + encryptedValue;
      window.location.href = newUrl;
    }
  };


  handleChangeInDropdown = (selected, drpIdentity) => {

    let page = this.state.pagination;
    if (drpIdentity === "ApplicationStatus") {
      if (selected.value === 0) {
        page.filterByStatus = 0;
      } else {
        const selectedStatus = this.state.applicationStatus.find(item => item.id === selected);
        page.filterByStatus = selectedStatus ? selectedStatus.name : null;
        this.setState({ filterStatusId: selected })
      }
    }
    if (drpIdentity === "TransactionType") {
      if (selected === 0) {
        page.filterByTransactionType = 0;
      } else {
        page.filterByTransactionType = selected;
      }
    }
    this.setState({ pagination: page });
    this.getAllTaskList();
  };

  getAllDetailsForGeneratePDF = (corporateMemberId) => {
    let request = [];
    request.push(corporateMemberId);
    this.setState({ isLoadingPDF: true });

    this.TaskListServices.getAllDetailsForGeneratePDF(request).then((response) => {
      if (response && response.status === 200) {
        let formattedDate = moment(new Date()).format("DDMMYYYYHHmmss");
        let filename = `MembershipInformation-${formattedDate}.pdf`;
        let file = new Blob([response.data], { type: "application/pdf" });
        let fileURL = URL.createObjectURL(file);
        window.open(fileURL, "_blank");
        saveAs(file, filename);
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoadingPDF: false });
    }).catch((error) => {
      this.swalServices.Error("Failed to fetch PDF");
    });
  }



  handleChangeForSelector = (e, identity) => {
    if (identity === 'OrdinaryEndorsers') {
      let taskDetails = { ...this.state.taskDetails };
      taskDetails.endorsersId1Name = e.target.value;
      let organisationList = taskDetails.endorsersId1Name && taskDetails.endorsersId1Name !== '' ?
        this.state.ordinaryEndorsers.filter(x => x.name.toUpperCase().indexOf(taskDetails.endorsersId1Name.toUpperCase()) > -1)
        : this.state.ordinaryEndorsers;
      this.setState({ taskDetails: taskDetails, filterOrdinaryEndorsersList: organisationList });
    }
    if (identity === 'AllEndorsers') {
      let taskDetails = { ...this.state.taskDetails };
      taskDetails.endorsersId2Name = e.target.value;
      let organisationList = taskDetails.endorsersId2Name && taskDetails.endorsersId2Name !== '' ?
        this.state.allEndorsers.filter(x => x.name.toUpperCase().indexOf(taskDetails.endorsersId2Name.toUpperCase()) > -1)
        : this.state.allEndorsers;
      this.setState({ taskDetails: taskDetails, filterAllEndorsers: organisationList });
    }
  }


  // resetAllTaskListDetails = () => {
  //   let resetMembership = this.state.membershipCommitteeApprovalDetails;
  //   let resetManagement = this.state.managementCommitteeApprovalDetails;
  //   let resetManagementAdditional = this.state.managementAdditionalInformationDetails;
  //   let resetMembershipAdditional = this.state.membershipAdditionalInformationDetails;

  //   // Membership Committee Approval
  //   resetMembership.comments = "";
  //   resetMembership.deadLineDate = "";
  //   resetMembership.isMembershipCommitteeApproval = true;
  //   resetMembership.taskId = 0;
  //   resetMembership.corporateMemberID = 0;
  //   resetMembership.membershipType = "";

  //   // Management Committee Approval
  //   resetManagement.comments = "";
  //   resetManagement.deadLineDate = "";
  //   resetManagement.isMembershipCommitteeApproval = false;
  //   resetManagement.taskId = 0;
  //   resetManagement.corporateMemberID = 0;
  //   resetManagement.membershipType = "";

  //   // Management Additional Info
  //   resetManagementAdditional.taskId = 0;
  //   resetManagementAdditional.additionalNotes = "";
  //   resetManagementAdditional.additionalDate = "";
  //   resetManagementAdditional.isMembershipCommitteeApproval = false;

  //   // Membership Additional Info
  //   resetMembershipAdditional.taskId = 0;
  //   resetMembershipAdditional.additionalNotes = null;
  //   resetMembershipAdditional.additionalDate = null;
  //   resetMembershipAdditional.isMembershipCommitteeApproval = true;

  //   // Reset Other States
  //   let resetIsMCApprovalSubmitted = false;
  //   let resetCompanyProfile = null;
  //   let resetWelcomeLetter = null;

  //   this.setState({
  //     membershipCommitteeApprovalDetails: resetMembership,
  //     managementCommitteeApprovalDetails: resetManagement,
  //     managementAdditionalInformationDetails: resetManagementAdditional,
  //     membershipAdditionalInformationDetails: resetMembershipAdditional,
  //     isMCApprovalSubmitted: resetIsMCApprovalSubmitted,
  //     companyProfile: resetCompanyProfile,
  //     welcomeletter: resetWelcomeLetter,
  //     isManagementCommitteeadditionalInfo: false
  //   });
  // };


  setFilterParametersForSelector = (id, identity, name) => {

    if (identity === "OrdinaryEndorsers") {

      if (id > 0) {
        this.getRepresentativesById(id, "OrdinaryMembers");
        let taskDetails = { ...this.state.taskDetails };
        let companies = [...this.state.ordinaryEndorsers];
        let companyName = companies.find(x => x.id === id);

        taskDetails.endorsersId1Name = companyName.name;
        this.setState({ taskDetails: taskDetails })
      }

    }


    if (identity === "AllEndorsers") {

      if (id > 0) {
        this.getRepresentativesById(id, "AllMembers");
        let taskDetails = { ...this.state.taskDetails };
        let endorsers = [...this.state.allEndorsers];
        let endorser = endorsers.find(x => x.id === id);

        taskDetails.endorsersId2Name = endorser.name;
        this.setState({ taskDetails: taskDetails })
      }

    }

  }

  handleChangeCheckBox = (e) => {

    const { name, checked } = e.target;
    let det = this.state.taskDetails;
    det[name] = checked;
    this.setState({ taskDetails: { ...det } });

  }



  render() {
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }
    return (
      <>
        <div className="main-body-section">
          <div className="bg-white pl-8 pt-10 pb-12">
            <div className="grid grid-cols-12 gap-6 w-full items-center">
              <div className="2xl:col-span-5 lg:col-span-6 col-span-12">
                <h2 className="text-xl theme-color">Date</h2>
                <div className="grid grid-cols-12 gap-6 items-center w-full">
                  <div className=" 2xl:col-span-5 lg:col-span-5 col-span-12 w-full">
                    <input
                      id="default"
                      name="dateFrom"
                      className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                      type="date"
                      value={this.state.pagination.dateFrom}
                      onChange={(e) => this.handleChangeForPagination(e)}
                    />
                  </div>
                  <div className=" 2xl:col-span-1 lg:col-span-2 col-span-12 w-full text-center">
                    <h2 className="text-xl theme-color">To</h2>
                  </div>
                  <div className=" 2xl:col-span-5 lg:col-span-5 col-span-12 w-full">
                    <input
                      id="default"
                      name="dateTo"
                      className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                      type="date"
                      value={this.state.pagination.dateTo}
                      onChange={(e) => this.handleChangeForPagination(e)}
                    />
                  </div>
                </div>
              </div>
              <div className="2xl:col-span-3 lg:col-span-4 col-span-12">
                <h2 className="pl-8 block text-xl font-medium  theme-color">
                  Application Status
                </h2>
                <div className="pl-8 border-l-[1px] border-[#757575]">
                  <DropdownSelect
                    optionArray={this.state.applicationStatus}
                    setFilterParameters={this.handleChangeInDropdown.bind(this)}
                    allowSelectAll={false}
                    value={this.state.filterStatusId}
                    drpIdentity="ApplicationStatus"
                  />
                </div>
              </div>

              <div className="2xl:col-span-3 lg:col-span-4 col-span-12">
                <h2 className="pl-8 block text-xl font-medium  theme-color">
                  Transaction Type
                </h2>
                <div className="pl-8 border-l-[1px] border-[#757575]">
                  <DropdownSelect
                    optionArray={this.state.transactionTypes}
                    setFilterParameters={this.handleChangeInDropdown.bind(this)}
                    allowSelectAll={false}
                    value={this.state.pagination.filterByTransactionType}
                    drpIdentity="TransactionType"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-6 gap-4 pt-10 px-8">
            <h2 className="col-start-1 col-end-3 text-3xl font-bold text-[#757575]">
              {`Total:${this.state.totalResultes}`}
            </h2>
            <div className="col-end-7 col-span-3 grid grid-cols-3 items-center">
              <div className="text-[#757575] text-xl">Search by Company </div>
              {/* <input className="col-span-2 text-lg font-bold  h-[40px] w-full text-[#757575]"/> */}
              <input
                id="default"
                className="col-span-2 text-lg font-bold  h-[55px] w-full text-[#757575] border-white"
                type="text"
                onChange={(e) => this.searchByName(e.target.value)}
              />
            </div>
          </div>
          <main className="pb-10">
            <div className="w-full mx-auto">
              <div className="relative">
                <div>
                  <div className=" mt-6">
                    <Table
                      columns={[
                        { name: "registrationDate", title: "Registration Date" },
                        { name: "companyAdminEmail", title: "Email Address" },
                        { name: "membershipType", title: "Membership Tier" },
                        { name: "companyName", title: "Organisation Name" },
                        { name: "companyUEN", title: "Organisation UEN" },
                        { name: "transactionTypeName", title: "Transaction Type", },
                        { name: "applicationStatusName", title: "Application Status" },
                        { name: "taskId", title: "Action" },
                      ]}
                      pagination={this.state.pagination}
                      rows={this.state.taskList}
                      sortingColumns={["registrationDate", "GeneralEmailAddress", "OrganisationName", "OrganisationUEN", "membershipTaskStatusId", "membershipType", "transactionTypeName"]}
                      isLoading={this.state.isLoading}
                      totalResultes={this.state.totalResultes}
                      totalCount={this.state.totalResultes}
                      setPagination={this.setPagination.bind(this)}
                      customScope={[
                        {
                          column: "taskId",
                          renderTableData: this.actions.bind(this),
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
        <div className="member-task-process">
          <MembershipTaskListProcess
            statusId={this.state.statusId}
            setAddeditModalOpen={this.state.setAddeditModalOpen}
            membershipType={this.state.membershipType}
            totalGroupAssets={this.state.totalGroupAssets}
            boardAndTopMtgList={this.state.boardAndTopMtgList}
            boardDirectorList={this.state.boardDirectorList}
            topManagementList={this.state.topManagementList}
            ordinaryMainProjectList={this.state.ordinaryMainProjectList}
            ordinaryProjectsCompletedList={this.state.ordinaryProjectsCompletedList}
            ordinaryProjectsInCompleteList={this.state.ordinaryProjectsInCompleteList}
            ProjectDevelopmentTypes={this.state.ProjectDevelopmentTypes}
            countriesDailing={this.state.countriesDailing}
            representativeDetails={this.state.representativeDetails}
            alternativeRepresentative={this.state.alternativeRepresentative}
            jobPosition={this.state.jobPosition}
            taskDetails={this.state.taskDetails}
            validState={this.state.validState}
            validStateForManagement={this.state.validStateForManagement}
            setModalOpen={() => {
              this.setState({ setAddeditModalOpen: false });
              window.location.reload();
            }}
            onClose={(e) => { e.stopPropagation(); this.setState({ setAddeditModalOpen: false }); }}
            setFilterParameters={this.setFilterParameters.bind(this)}
            setSendClarificationsFlag={this.setSendClarificationsFlag.bind(this)}
            setWelcomeletterFlag={this.setWelcomeletterFlag.bind(this)}

            isLoading={this.state.isLoading}
            transactionTypes={this.state.transactionTypes}
            applicationStatus={this.state.applicationStatus}
            handleChange={this.handleChange.bind(this)}
            mrMrs={this.state.mrMrs}
            sendPaymentLink={this.sendPaymentLink.bind(this)}
            isLoadingApprove={this.state.isLoadingApprove}
            membershipCommitteeApproval={this.state.membershipCommitteeApproval}
            managementCommitteeApproval={this.state.managementCommitteeApproval}
            membershipCommitteeApprovalDetails={this.state.membershipCommitteeApprovalDetails}
            managementCommitteeApprovalDetails={this.state.managementCommitteeApprovalDetails}
            handleChangeForApproval={this.handleChangeForApproval.bind(this)}
            committeeApproval={this.committeeApproval.bind(this)}
            resendCommitteeApproval={this.resendCommitteeApproval.bind(this)}
            handleChangeForRepresentative={(event) => this.handleChangeForRepresentative(event)}
            committeeApprovalStatusList={this.state.committeeApprovalStatusList}
            membershipAdditionalInformationDetails={this.state.membershipAdditionalInformationDetails}
            managementAdditionalInformationDetails={this.state.managementAdditionalInformationDetails}
            additionalInfomationSubmit={this.additionalInfomationSubmit.bind(this)}
            isLoadingClarification={this.state.isLoadingClarification}
            isLoadingWelcomeDetail={this.state.isLoadingWelcomeDetail}
            rejectApplicationForMember={this.rejectApplicationForMember}
            isLoadingReject={this.state.isLoadingReject}
            updateCorporateMemberUpdate={this.updateCorporateMemberUpdate.bind(this)}
            isMCApprovalSubmitted={this.state.isMCApprovalSubmitted}
            getAllDetailsForGeneratePDF={this.getAllDetailsForGeneratePDF.bind(this)}
            handleChangeCheckBox={this.handleChangeCheckBox.bind(this)}
            isLoadingPayment={this.state.isLoadingPayment}
            membershipCommitteeInfoAvailable={this.state.membershipCommitteeInfoAvailable}
            isMembershipCommitteeadditionalInfo={this.state.isMembershipCommitteeadditionalInfo}
            managementCommitteeInfoAvailable={this.state.managementCommitteeInfoAvailable}
            isManagementCommitteeadditionalInfo={this.state.isManagementCommitteeadditionalInfo}
            isManagementSendApprovalLoading={this.state.isManagementSendApprovalLoading}
            isMembershipSendApprovalLoading={this.state.isMembershipSendApprovalLoading}
            isMembershipSubmitLoading={this.state.isMembershipSubmitLoading}
            isManagementSubmitLoading={this.state.isManagementSubmitLoading}
            CountriesForCO={this.state.CountriesForCO}
            submissionTypeList={this.state.submissionTypeList}
            validateFieldForMembership={this.validateFieldForMembership.bind(this)}
            validateFieldForManagement={this.validateFieldForManagement.bind(this)}
            handleRadioClick={this.handleRadioClick.bind(this)}
            selfDeclarationComment={this.state.selfDeclarationComment}
            selfDeclaration={this.state.selfDeclaration}
          />
        </div>
        <div className="membership-task-list-process-sec">
          <SendForApprove
            organisationName={this.state.taskDetails.organisationName}
            generalEmailAddress={this.state.taskDetails.generalEmailAddress}
            setSendApproveModal={this.state.setSendApprove}
            setOpenModal={() => this.setState({ setSendApprove: false })}
            onClose={(e) => {
              e.stopPropagation();
              this.setState({ setSendApprove: false });
            }}
          />
          <div className="send-clarification-model">
            <SendClarifications
              clarificationModal={this.state.setSendClarifications}
              clarification={this.state.clarification}
              setOpenModal={() => this.setState({ setSendClarifications: false })}
              onTinyEceEditorChange={(data) =>
                this.handleChangeClarificationDetails(data)
              }
              // onClose={(e) => {e.stopPropagation();
              //   this.setState({ setSendClarifications: false });
              // }}
              // getClarificationDetails={this.getClarificationDetails.bind(this)}
              saveClarificationDetails={this.saveClarificationDetails.bind(
                this
              )}
              isLoading={this.state.isLoadingClarification}

            />
          </div>
          <div className="send-welcomeletter-model">
            <WelcomeLetter
              clarificationModal={this.state.setWelcomeletter}
              clarification={this.state.welcomeletter}
              setOpenModal={() => this.setState({ setWelcomeletter: false })}
              onTinyEceEditorChange={(data) =>
                this.handleChangeWelcomeletterDetails(data)
              }
              // onClose={(e) => {e.stopPropagation();
              //   this.setState({ setSendClarifications: false });
              // }}
              // getClarificationDetails={this.getClarificationDetails.bind(this)}
              saveClarificationDetails={this.saveWelcomeLetterDetail.bind(
                this
              )}
              isLoading={this.state.isLoadingWelcomeDetail}

            />
          </div>
          <SendPaymentLink
            organisationName={this.state.taskDetails.organisationName}
            generalEmailAddress={this.state.taskDetails.generalEmailAddress}
            paymentLinkModal={this.state.setPaymentLink}
            setOpenModal={() => this.setState({ setPaymentLink: false })}
            onClose={(e) => {
              e.stopPropagation();
              this.setState({ setPaymentLink: false });
            }}
          />
          <SendQuotation
            organisationUEN={this.state.taskDetails.organisationName}
            generalEmailAddress={this.state.taskDetails.generalEmailAddress}
            setSendQuotationModal={this.state.sendReject}
            setOpenModal={() => this.setState({ sendReject: false })}
            onClose={(e) => {
              e.stopPropagation();
              this.setState({ sendReject: false });
            }}
          />
          <SendInvoice
            organisationName={this.state.taskDetails.organisationName}
            generalEmailAddress={this.state.taskDetails.generalEmailAddress}
            setSendInvoiceModal={this.state.sendInvoice}          
            setOpenModal={() => this.setState({ sendInvoice: false })}
            onClose={(e) => {
              e.stopPropagation();
              this.setState({ sendInvoice: false });
            }}
          />
          <EscalateModal
            organisationName={this.state.taskDetails.organisationName}
            generalEmailAddress={this.state.taskDetails.generalEmailAddress}
            setSendInvoiceModal={this.state.sendEscalation}
            setOpenModal={() => this.setState({ sendEscalation: false })}
            onClose={(e) => {
              e.stopPropagation();
              this.setState({ sendEscalation: false });
              window.location.reload();
            }}
          />
        </div>
      </>
    );
  }
  
}
